<template>
    <div class="reserve-confirm">
        <div class="mb-4 text-end">
            <button @click="toggleCancelDisp" v-if="cancel_disp" class="bscBtn">
                {{ word_chg('キャンセルした予約を表示させない') }}
            </button>
            <button @click="toggleCancelDisp" v-else class="bscBtn">
                {{ word_chg('キャンセルした予約を表示する') }}
            </button>
        </div>
        <!-- {{ reservation_node }} -->
      <ul class="reserve-confirm__list" v-if="reservations.length > 0">
        <li class="reserve-confirm__lists" v-for="node in reservations" :key="node">
            <p class="reserve-confirm__item d-flex align-items-center">
                <span class="reserve-confirm__icon reserve-confirm__icon--red" v-if="node.is_cancel ==0">{{ word_chg('予約済')}}</span>
                <span class="reserve-confirm__icon reserve-confirm__icon--red" v-else-if="node.is_cancel ==1">{{ word_chg('キャンセル')}}</span>
                <span class="reserve-confirm__category">{{ node.label }}</span>
                <a class="reserve-confirm__icon text-dark" @click="detailToggle(node)">
                    -{{ word_chg('詳細')}}-
                </a>
            </p>
            <p class="reserve-confirm__description mb-2">
                {{ node.start_date_str }} {{ youbi(node) }}
                <span v-for="item in node.item_data" :key="item">
                    <!-- {{ item }} -->
                    {{ item.start_time_str }} - {{ item.end_time_str }}/
                </span>
            </p>
            <!-- {{ get_node_ledger_data(node ) }} -->
            <p class="reserve-confirm__description" v-if="node.detail_disp_sw">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td style="font-size:90%;font-weight: normal;">{{ word_chg('ご予約者') }}</td>
                            <td>{{ node.reservation_m_label }}様</td>
                            <td style="font-size:90%;font-weight: normal;">{{ word_chg('走行ドライバー') }}</td>
                            <td class="text-end" v-if="node.use_m_id > 0">{{ node.use_m_label }}様</td>
                            <td class="text-end" v-else-if="node.use_guest_id> 0">{{ word_chg('ゲスト会員') }}</td>
                        </tr>
                        <tr>
                            <td style="font-size:90%;font-weight: normal;">{{ word_chg('車両名') }}</td>
                            <td>
                                {{ list_val_set(get_ledger_value_by_param(get_node_ledger_data(node), 'car_id'), getCarData) }}
                            </td>
                            <td style="font-size:90%;font-weight: normal;">{{ word_chg('PONDER') }}</td>
                            <td class="text-end">
                                <span v-if="get_ledger_value_by_param(get_node_ledger_data(node), 'car_ponder')">
                                    {{ get_ledger_value_by_param(get_node_ledger_data(node), 'car_ponder') }}
                                </span>
                                <span v-else>未定</span>
                            </td>
                        </tr>
                        <tr>
                            <td style="font-size:90%;font-weight: normal;">{{ word_chg('ゼッケン') }}</td>
                            <td>
                                <span v-if="get_ledger_value_by_param(get_node_ledger_data(node), 'car_number')">
                                    {{ get_ledger_value_by_param(get_node_ledger_data(node), 'car_number') }}
                                </span>
                                <span v-else>未定</span>
                            </td>
                            <td style="font-size:90%;font-weight: normal;">{{ word_chg('タイプ') }}</td>
                            <td>
                                {{ list_val_set(get_ledger_value_by_param(get_node_ledger_data(node), 8), get_ledger_sel_ledger_dfp_by_param(get_node_ledger_data(node), 8)) }}
                            </td>
                        </tr>
                        <tr>
                            <td style="font-size:90%;font-weight: normal;">{{ word_chg('車種') }}</td>
                            <td>
                                <span v-if="get_ledger_value_by_param(get_node_ledger_data(node), 9)" class="">
                                    {{ get_ledger_value_by_param(get_node_ledger_data(node), 9) }}
                                </span>
                                <span v-else>未定</span>
                            </td>
                            <td style="font-size:90%;font-weight: normal;">{{ word_chg('車両情報') }}</td>
                            <td>
                                {{ list_val_set(get_ledger_value_by_param(get_node_ledger_data(node), 10), get_ledger_sel_ledger_dfp_by_param(get_node_ledger_data(node), 10)) }}
                            </td>
                        </tr>
                        
                        <tr>
                            <td style="font-size:90%;"></td>
                            <td></td>
                            <td style="font-size:90%;">{{ word_chg('料金') }}</td>
                            <td>¥{{ node.reserve_price }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td style="text-align: right;" colspan="4">

                                <span v-if="CancelDateNG(node.range_start_date) && node.is_cancel == 0">
                                    {{ word_chg('キャンセルご希望の場合はお問い合わせ下さい') }}
                                </span>
                                <p class="members-carinfo__btn" style="width: 100%;" v-else-if="node.is_cancel==0">
                                    <a @click="cancelConfirm(node.reservation_node_id)"  class="button" >{{ word_chg('キャンセル') }}</a>
                                </p>
                                <span v-else-if="node.is_cancel==1">{{ word_chg('キャンセルしました') }}</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </p>
        </li>

      </ul>
      <div v-else-if="load_finish">
        {{ word_chg('予約はありません。') }}
      </div>
      <div v-else>
        {{ word_chg('読み込み中') }}
      </div>
    </div>
    <bs-page-nav :pager_sw="true" :load_pager_obj="pager_obj" :pager_key="'reservation_node'" @to_click_event="pageAction"></bs-page-nav>

</template>
<style scoped>
    .bscBtn {
        display:inline-block;padding:.7501875469rem 1.200300075rem;border:1px solid #646464;background:#e6e6e6;border-radius:.5626406602rem;color:#646464;font-size:1.5003750938rem;font-weight:normal;line-height:1em;letter-spacing:.05em;text-decoration:none
    }
</style>

<script>
import BsPageNav from '../../molecules/BsPageNav.vue'
import { mapState } from 'vuex';
import moment from 'moment'
import config from '../../../const'
import axios from 'axios'
import Common from '../../../common/common'
export default {
    name: 'ListReservedView',
    data: function () {
        return {
            reservation_node: [],
            reservation_node_u: [],
            reservation_node_r: [],
            load_finish: false,
            page: 0,
            pagelimit: 8,
            pager_obj: {},
            cancel_disp: false
        }
    },
    props: {
        // displayClass: {
        //     type: String,
        //     default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        // },
    },
    components: {
        // BsPageTitle,
        BsPageNav,
    },
    methods: {
        toggleCancelDisp(){
            if(this.cancel_disp){
                this.cancel_disp = false;
            }else{
                this.cancel_disp = true;
            }
            this.pageAction(0);
        },
        pageAction(page){
            console.log('pageAction', page);
            this.page = page;
            this.loadReservationNode();
        },
        cancelConfirm(target){
            if(window.confirm(this.word_chg('キャンセルします。よろしいですか？'))){
                this.cancelAction(target);
                // return;
            }
            else{
                return;
            }
        },
        cancelAction(target) {
            const param = {};
            param['is_cancel'] = 1;

            param['id'] = target;

            return this.$store.dispatch('updateBasic', {data: param, target: 'reservation_node' })
            .then((response) => {
                // this.back()
                if(response){
                    alert(this.word_chg('キャンセルしました'));
                }
            })
            .catch(
                () => {
                err => Promise.reject(err);
                alert(this.word_chg('キャンセルできませんでした'));
                }
            )
            .finally(async ()=>{
                await this.loadReservationNode();
        // await this.loadReservationNodeU();
        // await this.loadReservationNodeR();
            })
        },
        detailToggle(node){
            node.detail_disp_sw = (node.detail_disp_sw)? false: true;
        },
        async loadReservationNode () {
            const params = {};
            params['type'] = 'drive';
            // params['use_m_id'] = this.$store.state.auth.userId;
            params['stat'] = [1];
            params['start_date'] = moment().format('YYYY-MM-DD');
            if(!this.cancel_disp){
                params['is_cancel'] = 0;
            }
            params['m_id_sql'] = JSON.stringify({
                'use_m_id': this.$store.state.auth.userId,
                'reservation_m_id': this.$store.state.auth.userId
            });
            params['pageorder'] = "(SELECT DATE_FORMAT(node_item_data.start_date, '%H%i%s') FROM node_item_data WHERE node_item_data.node_id = node_data.id ORDER BY node_item_data.start_date ASC LIMIT 1 OFFSET 0)";
            params['pagesort'] = 'ASC';
            params['pagelimit'] = this.pagelimit;
            if(this.page >= 0) params['p'] = this.page;

            const params_ = Common.createParams(params);
            axios.post(
                config.BASE_API_URL + '/reservation_node/lists',
                params_,
                {
                headers: this.axiosHeader
                }
            )
            .then(
                (response) => {
                    console.log('loadReservationNode response', response);
                    this.reservation_node = (response && response.data && typeof response.data === 'object' && typeof response.data.body === 'object')? response.data.body: [];
                    this.pager_obj = (response && response.data && typeof response.data === 'object' && typeof response.data.pager === 'object')? {reservation_node: response.data.pager}: {};
                }
            )
            .catch((err) => {
                console.log('loadDashboard err c', err);
                // this.search_sales = [];
                this.reservation_node = [];
            })
            .finally(() => {
                this.$forceUpdate();
            });

            // params['end_date'] = moment().format('YYYY-MM-DD');
            // return this.$store.dispatch('fetchBasicLists', {data: params, target: 'reservation_node'})
            //             .catch(err => Promise.reject(err))
            //             .then(() => {
            //                 console.log('loard complete reservation_node');
            //                 console.log('this', this.$store.state.apidata.reservation_node);
            //             })
            //             .finally(() => {
            //                 console.log('finally', this.$store.state.apidata.reservation_node);
            //             })
        },
        async loadReservationNodeR () {
            const params = {};
            params['type'] = 'drive';
            params['use_m_id'] = 0;
            params['reservation_m_id'] = this.$store.state.auth.userId;
            params['stat'] = [1];
            // params['stat'] = [1];
            // params['financial_status'] = 10;
            const params_ = Common.createParams(params);
            axios.post(
                config.BASE_API_URL + '/reservation_node/lists',
                params_,
                {
                headers: this.axiosHeader
                }
            )
            .then(
                (response) => {
                    this.reservation_node_r = (response && response.data && typeof response.data === 'object' && typeof response.data.body === 'object')? response.data.body: [];
                }
            )
            .catch((err) => {
                console.log('loadDashboard err c', err);
                // this.search_sales = [];
                this.reservation_node_r = [];
            })
            .finally(() => {
                this.$forceUpdate();
            });
        },
        async loadReservationNodeU () {
            const params = {};
            params['type'] = 'drive';
            params['use_m_id'] = this.$store.state.auth.userId;
            params['stat'] = [1];
            // params['stat'] = [1];
            // params['financial_status'] = 10;
            const params_ = Common.createParams(params);
            axios.post(
                config.BASE_API_URL + '/reservation_node/lists',
                params_,
                {
                headers: this.axiosHeader
                }
            )
            .then(
                (response) => {
                    this.reservation_node_u = (response && response.data && typeof response.data === 'object' && typeof response.data.body === 'object')? response.data.body: [];
                }
            )
            .catch((err) => {
                console.log('loadDashboard err c', err);
                // this.search_sales = [];
                this.reservation_node_u = [];
            })
            .finally(() => {
                this.$forceUpdate();
            });
        },
        async loadFinish(){
            this.load_finish = true;
        }
    },
    computed: {
        ...mapState({
            // reservation_node: state => state.apidata.reservation_node,
            // paddock_list: state => state.apidata.drive_node_category,
            user: state => state.apidata.user,
        }),
        // login user
        getMyData: function(){
            const mydata = this.user.find((data) => {
            return data.id == this.$store.state.auth.userId;
            })
            return mydata;
        },
        getCarData: function(){
            if(this.getMyData.cars){
                return this.getMyData.cars;
            }
            return [];
        },
        list_val_set: function(){
            return function(val, options){
                console.log('list_val_set options', options);
                if(typeof options === 'object'){
                    const option = options.find((data) => {
                        return data.key == val;
                    })
                    return (typeof option === 'object')? this.word_chg(option.label): '';
                }
                return val;
            }
        },
        get_node_ledger_data: function(){
            return function (node){
                const tmps = [];
                if(
                    typeof node === 'object'
                    && typeof node.ledger_data === 'object'
                ){
                    Object.values(node.ledger_data).forEach(ledgers => {
                        if(
                            typeof ledgers === 'object'
                        ){
                            Object.values(ledgers).forEach(ledger => {
                                tmps.push(ledger);
                            })
                        }
                    })
                }
                return tmps;
            }
        },
        get_ledger_value_by_param: function(){
            const get_func = this.get_ledger_by_param;
            return function(ledgers, param){
                return (typeof get_func(ledgers,param) === 'object')? get_func(ledgers,param).value: '';
            }
        },
        get_ledger_sel_ledger_by_param: function(){
            const get_func = this.get_ledger_by_param;
            return function(ledgers, param){
                return (typeof get_func(ledgers,param) === 'object')? get_func(ledgers,param).sel_ledger: '';
            }
        },
        get_ledger_sel_ledger_dfp_by_param: function(){
            const get_func = this.get_ledger_sel_ledger_by_param;
            return function(ledgers, param){
                return (typeof get_func(ledgers,param) === 'object')? get_func(ledgers,param).default_param: '';
            }
        },
        get_ledger_by_param: function(){
            return function(ledgers, param){
                if(
                    typeof ledgers === 'object' 
                    && ledgers.find(led => {return (led.type_id == param || led.sel_ledger.relation_column == param)})
                ){
                    return ledgers.find(led => {return (led.type_id == param || led.sel_ledger.relation_column == param)});
                }
                return false;
            }
        },
        CancelDateNG: function(){
            return function(date){
                const now = parseInt(moment().format('YYYYMMDD'));
                const cancel_limit = parseInt(moment().add(2, 'd').format('YYYYMMDD'));
                const target = parseInt(moment(date).format('YYYYMMDD'));
                // console.log('CancelDateNG now', now);
                // console.log('CancelDateNG cancel_limit', cancel_limit, );
                // console.log('CancelDateNG target', target);
                if(target <= cancel_limit){
                    return true;
                }else if(target < now){
                    return true;
                }else{
                    return false;
                }
            }
        },
        youbi: function (){
            return function(node){
                return moment(node.start_date_str).format("ddd");
            }
        },
        reservations: function(){
            // const tmps_node = [...this.reservation_node_u, ...this.reservation_node_r];
            const tmps_node = [...this.reservation_node];
            if(Object.keys(tmps_node).length > 0){
                const ttt = tmps_node.map(node => {
                    node.detail_disp_sw = false;
                    return node;
                });

                ttt.sort((a, b) => {
                    if(parseInt(a.item_start) > parseInt(b.item_start)){
                        return 1;
                    }else{
                        return -1;
                    }
                });
                return ttt;
            }
            return [];
        },
        axiosHeader: function(){
            return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
        },
    },

    async created () {
        await this.loadReservationNode();
        // await this.loadReservationNodeU();
        // await this.loadReservationNodeR();
        await this.loadFinish();
        // this.loaddriveNode();
        // this.loadLedgerType();
    },
}
</script>
